module.exports = __webpack_public_path__ + "font/d0066537ab6a4c6f8285a5aeb3ba5f09.woff2";